import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalSearch } from "../hooks/useGlobalSearch";

export default function GlobalSearchModal({ open, onClose }) {
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const {
    query,
    setQuery,
    results,
    loading,
    search,
  } = useGlobalSearch();

  // 🔥 Auto focus when opened
  useEffect(() => {
    if (open) {
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [open]);

  // ⌨ Esc to close
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center pt-24">
      <div className="bg-white w-full max-w-2xl rounded-2xl shadow-xl">

        {/* INPUT */}
        <div className="border-b p-4">
          <input
            ref={inputRef}
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              search(e.target.value);
            }}
            placeholder="Search ticket, order, phone, name…"
            className="w-full text-lg outline-none"
          />
        </div>

        {/* RESULTS */}
        <div className="max-h-96 overflow-y-auto">
          {loading && (
            <p className="p-4 text-gray-400">Searching…</p>
          )}

          {!loading && results.length === 0 && query && (
            <p className="p-4 text-gray-400">No results found</p>
          )}

          {results.map((t) => (
            <div
              key={t._id}
              onClick={() => {
                navigate(`/tickets/${t._id}`);
                onClose();
              }}
              className="p-4 cursor-pointer hover:bg-gray-50 border-b"
            >
              <div className="flex justify-between">
                <p className="font-medium">{t.ticketId}</p>
                <span className="text-xs px-2 py-1 rounded bg-indigo-100 text-indigo-600">
                  {t.status}
                </span>
              </div>
              <p className="text-sm text-gray-500">
                {t.customer?.name} • {t.order?.orderId}
              </p>
            </div>
          ))}
        </div>

        {/* FOOTER */}
        <div className="p-3 text-xs text-gray-400 flex justify-between">
          <span>Enter → Open</span>
          <span>Esc → Close</span>
        </div>
      </div>
    </div>
  );
}